import React from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import UploadProformaInvoicePageModal from "@/features/invoices/proforma-invoices/upload-proforma-invoice-page-modal";
import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import UploadBankRemittanceReceiptPageModal
  from "@/features/invoices/bank-remittance-receipts/upload-bank-remittance-receipt-page-modal";
import { LightPayment } from "@/features/invoices/payment/payment.type";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  payment: LightPayment;
}

export default function AddBankRemittanceReceiptModal({ isOpen, onClose, payment }: Props) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent borderRadius={"8px"} overflow={"hidden"} maxWidth={"1600px"}>
        <ModalBody display="flex" flexDirection={"column"} gap={"12px"} >
          <UploadBankRemittanceReceiptPageModal
            payment={payment}
            handleClose={handleClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
